<script>
export default {
    methods: {
        $can(permissionName) {
            if (this.$store.getters.getProfile.permissions === undefined) {
                return false;
            }

            return this.$store.getters.getProfile.permissions.filter(row => {
                return row.name === permissionName;
            }).length;
        }
    }
};
</script>
